const FALLBACK_ICON = "link";

function hasAppSwitcher(route) {
  return Boolean(route.meta?.appSwitcher) && typeof route.meta?.icon === "string" && route.meta.icon;
}

/**
 * The icon the app switcher shows for the app that owns `path`.
 * Falls back to the matched route's own icon, then a plain link icon.
 */
function appIconForRoute(router, path) {
  let resolved;
  try {
    resolved = router.resolve(path);
  } catch {
    return FALLBACK_ICON;
  }
  const matched = [...(resolved?.matched || [])].reverse();
  const app = matched.find((route) => route.meta?.app)?.meta.app;
  if (app) {
    const switcher = router.getRoutes().find((route) => route.meta?.app === app && hasAppSwitcher(route));
    if (switcher) return switcher.meta.icon;
  }
  return matched.find((route) => typeof route.meta?.icon === "string" && route.meta.icon)?.meta.icon || FALLBACK_ICON;
}

export { FALLBACK_ICON, appIconForRoute };
